export const UNASSIGNED_AREA_ID = '00000000-0000-0000-0000-000000000000';
